import React from 'react';
import { useVocabulary } from '../context/VocabularyContext';

// Import components
import { LoadingScreen } from './LoadingScreen';
import { ErrorScreen } from './ErrorScreen';
import { MainMenu } from './MainMenu';
import { SessionScreen } from './SessionScreen';
import { ResultsScreen } from './ResultsScreen';

export function GermanVocabularyApp() {
  const { state } = useVocabulary();
  const { loading, error, appState } = state;

  // Loading state
  if (loading) {
    return <LoadingScreen />;
  }

  // Error state
  if (error) {
    return <ErrorScreen error={error} />;
  }

  // Render based on app state
  switch (appState) {
    case 'menu':
      return <MainMenu />;
    case 'session':
      return <SessionScreen />;
    case 'results':
      return <ResultsScreen />;
    default:
      return <MainMenu />;
  }
} 